export interface WalletState {

}

export const initialState: any = []